import { Shield, Target, Users, Award } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Shield className="w-10 h-10" />,
      title: 'Comparaison Transparente',
      description: 'Nous analysons chaque plateforme avec objectivité. Aucun avis biaisé, seulement des faits vérifiés pour vous aider à choisir.',
    },
    {
      icon: <Target className="w-10 h-10" />,
      title: 'Sélection Rigoureuse',
      description: 'Seules les plateformes agréées et sécurisées figurent dans notre sélection. Votre sécurité est notre priorité absolue.',
    },
    {
      icon: <Users className="w-10 h-10" />,
      title: 'Expertise du Marché',
      description: 'Notre équipe suit quotidiennement l\'évolution du marché français des paris en ligne pour vous offrir les meilleures opportunités.',
    },
    {
      icon: <Award className="w-10 h-10" />,
      title: 'Bonus Exclusifs',
      description: 'Accédez à des offres promotionnelles que vous ne trouverez nulle part ailleurs. Nous négocions les meilleures conditions pour vous.',
    },
  ];

  return (
    <section id="a-propos" className="py-20 bg-dark-bg relative overflow-hidden">
      {/* Hexagonal background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-64 h-64 border-4 border-toxic-green rotate-45 transform -translate-x-32 -translate-y-32"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 border-4 border-toxic-green rotate-45 transform translate-x-48 translate-y-48"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16" itemScope itemType="http://schema.org/Organization">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" itemProp="name">
            À Propos de <span className="text-toxic-green">Hexabet Connect</span>
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed mb-8" itemProp="description">
            Hexabet Connect est votre guide indépendant dans l'univers des paris en ligne français. Nous ne sommes pas affiliés à une seule plateforme, mais nous vous aidons à trouver celle qui correspond parfaitement à vos besoins et à votre style de jeu.
          </p>
          <p className="text-lg text-gray-400 leading-relaxed" itemProp="slogan">
            Notre mission est simple : vous faire économiser du temps et de l'argent en comparant les offres, en analysant les bonus et en vous donnant toutes les informations nécessaires pour prendre des décisions éclairées. Nous croyons que chaque parieur mérite la meilleure expérience possible.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-dark-card border border-gray-800 rounded-xl p-6 hover:border-toxic-green transition-all transform hover:scale-105"
            >
              <div className="text-toxic-green mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-white" itemProp="name">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed" itemProp="description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;

